<template src='./conciliationCriteria.pug' lang='pug'></template>

<script>
export default {
  name: 'ConciliationCriteria',

  props: {
    criteria: {
      type: Object,
      required: true
    },
    order: {
      type: Number,
      required: true
    },
    handleEdit: {
      type: Function,
      required: true
    },
    handleRemove: {
      type: Function,
      required: true
    }
  },

  computed: {
    btnEditTitle () {
      return this.criteria.criterioEmUso
        ? this.$t('planoConciliacao.validacao.criterioConcilEmUsoEditar')
        : this.$t('planoConciliacao.labels.editar')
    },
    btnRemoveTitle () {
      return this.criteria.criterioEmUso
        ? this.$t('planoConciliacao.validacao.criterioConcilEmUsoExcluir')
        : this.$t('planoConciliacao.labels.remover')
    }
  }
}
</script>

<style scoped>
.attribute > .att-field {
  display: inline-block;
}

.list-complete-item:hover {
  cursor: move;
  background-color: #f5f5f5;
}

.list-complete-item {
  padding-top: 18px;
  padding-bottom: 18px;
  height: auto;
  word-wrap: break-word;
  min-height: 58px;
  border: 1px solid #ddd;
  transition: all 1s;
}

.fa.action {
  margin: 0;
}

.att-field.order {
  margin-left: 30px;
}

.att-field.buttons {
  padding-right: 7px;
}

.font-sized {
  font-size: 1.1vh;
}
</style>



// WEBPACK FOOTER //
// ConciliationCriteria.vue?3bcf3614